<template>
    <div>
        <slot name="trigger">
            <button
                v-t="$t('corrections.report.get')"
                class="button button--blank"
                type="button"
                @click="toggleModal"
            ></button>
        </slot>
        <Modal v-if="isOpen" title="Get report" @closed="isOpen = false">
            <template #content>
                <Spinner v-if="loading" />
                <div style="text-align: center">
                    <button
                        v-t="$t('corrections.report.get')"
                        class="button button--big"
                        @click.prevent="getReport"
                    ></button>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import { getCorrectionReport } from '../../api/corrections';

export default {
    name: 'CorrectionsGetReport',
    components: {
        Modal,
    },
    data() {
        return {
            isOpen: false,
            loading: false,
        };
    },
    methods: {
        toggleModal() {
            this.isOpen = !this.isOpen;
        },
        async getReport() {
            try {
                this.loading = true;
                const report = await getCorrectionReport(this.$route.params.id);
                const url = window.URL.createObjectURL(new Blob([report]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${formatDate(new Date())}-corrections.xlsx`);
                document.body.appendChild(link);
                link.click();
            } catch (e) {
                console.log(e);
                this.$store.dispatch('pushToast', {
                    id: Date.now(),
                    type: 'error',
                    title: this.$t('corrections.report.error'),
                    message: this.$t('corrections.item.tryAgain'),
                });
            } finally {
                this.loading = false;
            }
        },
    },
};

function formatDate(date) {
    const d = new Date(date);
    return `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}-${('0' + d.getDate()).slice(
        -2
    )}`;
}
</script>
